/**
 * The Google Calendar mark on Integracje's Google row (owner-approved polish, 4 November 2026).
 *
 * **A STAND-IN, to be replaced by Google's official Calendar asset before merge.** It is drawn here
 * so the row has its mark while the asset is fetched from Google's brand resources under their
 * terms; the official file replaces this drawing one for one, keeping the name and the `aria-hidden`.
 * The artwork fills its box edge to edge; the row sets it inside the same neutral tile as Apple's
 * and the call link's glyphs, so the three marks line up.
 * Its colours are Google's four brand hues, which is the one place a literal colour is the content
 * rather than a styling choice — a theme token in a brand mark would be a different mark.
 *
 * Apple gets NO mark (owner, 4 November 2026): Apple does not license its icons for this, so its
 * row wears an ordinary outline calendar glyph in a neutral tile, drawn by the row itself.
 *
 * `aria-hidden`: the row's title already says „Kalendarz Google".
 */

interface MarkProps {
  readonly className?: string;
}

export function GoogleCalendarMark({ className }: MarkProps) {
  return (
    <svg className={className} viewBox="4 4 24 24" aria-hidden="true" focusable="false">
      <rect x="4" y="4" width="24" height="24" rx="3" fill="#ffffff" />
      <path d="M4 22h6v6H7a3 3 0 0 1-3-3z" fill="#1e8e3e" />
      <path d="M22 4h3a3 3 0 0 1 3 3v3h-6z" fill="#1967d2" />
      <path d="M22 10h6v12h-6z" fill="#fbbc04" />
      <path d="M10 22h12v6H10z" fill="#34a853" />
      <path d="M22 22h6l-6 6z" fill="#ea4335" />
      <path d="M4 7a3 3 0 0 1 3-3h15v6H4z" fill="#4285f4" />
      <text
        x="16"
        y="20"
        textAnchor="middle"
        fontSize="9"
        fontWeight="700"
        fontFamily="system-ui, sans-serif"
        fill="#1967d2"
      >
        31
      </text>
    </svg>
  );
}
